// 🎯 مصدر واحد لاسم البراند - كل مكان في الفرونت (i18n.js، Header،
// Login، عناوين الصفحة...) بيستورد من هنا بدل ما يكتب "TEKNORA" صريح.
// القيمة بتتقرا وقت التشغيل من public/config.js (window.RUNTIME_ENV،
// نفس آلية SUPERSET_DASHBOARD_ID الموجودة أصلاً) - يعني نفس الـ build
// بيشتغل لأي عميل من غير ما نحتاج نعمل build منفصل لكل واحد. القيمة
// الافتراضية هنا هي اسم العميل الأصلي (تكنورا) بالظبط، فأي بيئة مالهاش
// config.js فيه BRAND_NAME مش هتتأثر خالص
const RUNTIME_ENV = (typeof window !== 'undefined' && window.RUNTIME_ENV) || {};

export const BRAND = {
  name: RUNTIME_ENV.BRAND_NAME || 'TEKNORA EAM',
  nameAr: RUNTIME_ENV.BRAND_NAME_AR || 'تكنورا',
};

export default BRAND;
